import {createTheme} from '@mui/material/styles'
import type {ThemeParams} from '@tma.js/sdk'

export const createAppTheme = (themeParams: ThemeParams, mainColor: string) => {
    console.log(`${themeParams} is dark: ${themeParams.isDark} is disabled, mainColor: ${mainColor}`)
    const isDark = true

    return createTheme({
        breakpoints: {
            values: {
                xs: 0,
                sm: 600,
                md: 960,
                lg: 1280,
                xl: 1920,
            },
        },
        palette: {
            mode: isDark ? 'dark' : 'light',
            primary: {
                main: '#2481cc',
            },
            secondary: {
                main: '#2481cc',
            },
            background: {
                default: 'black',
                paper: (isDark ? '#1e1e1e' : '#f5f5f5'),
            },
            text: {
                primary: (isDark ? '#ffffff' : '#000000'),
                secondary: (isDark ? '#aaaaaa' : '#707579'),
            },
        },
        typography: {
            fontFamily: '"Montserrat", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
            h1: {
                fontSize: '2.5rem',
                fontWeight: 700,
                lineHeight: 1.2,
            },
            h2: {
                fontSize: '2rem',
                fontWeight: 700,
                lineHeight: 1.3,
            },
            h3: {
                fontSize: '1.5rem',
                fontWeight: 600,
                lineHeight: 1.4,
            },
            h4: {
                fontSize: '1.25rem',
                fontWeight: 600,
                lineHeight: 1.4,
            },
            h5: {
                fontSize: '1.125rem',
                fontWeight: 500,
                lineHeight: 1.5,
            },
            h6: {
                fontSize: '1rem',
                fontWeight: 500,
                lineHeight: 1.5,
            },
            body1: {
                fontSize: '1rem',
                fontWeight: 400,
                lineHeight: 1.5,
            },
            body2: {
                fontSize: '0.875rem',
                fontWeight: 400,
                lineHeight: 1.43,
            },
            subtitle1: {
                fontSize: '1rem',
                fontWeight: 500,
                lineHeight: 1.75,
            },
            subtitle2: {
                fontSize: '0.875rem',
                fontWeight: 500,
                lineHeight: 1.57,
            },
        },
        components: {
            MuiButton: {
                styleOverrides: {
                    root: {
                        width: '100%',
                        height: '50px',
                        borderRadius: '24px',
                        textTransform: 'none',
                        backgroundColor: 'rgba(255, 255, 255, 0.15)',
                        boxShadow: '0 5px 10px rgba(0, 0, 0, 0.3)',
                        border: '1px solid rgba(255, 255, 255, 0.05)',
                        backdropFilter: 'blur(7px) saturate(200%)',
                        WebkitBackdropFilter: 'blur(7px) saturate(200%)',
                        '&:hover': {
                            backgroundColor: 'rgba(255, 255, 255, 0.1)',
                        },
                        '&:disabled': {
                            backgroundColor: 'rgba(255, 255, 255, 0.1)',
                            opacity: 0.7,
                            cursor: 'not-allowed',
                        },
                    }
                },
            },
            MuiIconButton: {
                styleOverrides: {
                    root: {
                        width: '50px',
                        height: '50px',
                        borderRadius: '360px',
                        backgroundColor: 'rgba(0, 0, 0, 0.05)',
                        boxShadow: '0 5px 10px rgba(0, 0, 0, 0.3)',
                        border: '1px solid rgba(255, 255, 255, 0.2)',
                        backdropFilter: 'blur(7px) saturate(200%)',
                        WebkitBackdropFilter: 'blur(7px) saturate(200%)',
                        '&:hover': {
                            backgroundColor: 'rgba(0, 0, 0, 0.1)',
                        },
                    }}
                },
                MuiCard: {
                    styleOverrides: {
                        root: {
                            borderRadius: 12,
                        },
                    },
                },
                MuiDrawer: {
                    styleOverrides: {
                        paper: {
                            backgroundColor: 'rgba(0, 0, 0, 0.3)',
                            backdropFilter: 'blur(7px) saturate(200%)',
                            WebkitBackdropFilter: 'blur(7px) saturate(200%)',
                            borderTopLeftRadius: '24px',
                            borderTopRightRadius: '24px',
                            borderTop: '1px solid rgba(255, 255, 255, 0.2)',
                            boxShadow: '0 -8px 32px rgba(0, 0, 0, 0.4)',
                        },
                    },
                },
            },
        })
}
